export default __webpack_public_path__ + "static/media/placeholder_store05-it-web.b0641262.png";